import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    appKey = '',
    appSecret = '',
    appDomain = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.statCounter.statApp.saveApp, {
        id,
        name,
        appKey,
        appSecret,
        appDomain,
    }, options);
    if (error) return { error, status };
    return content || {};
};
